











import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteVoucherModel, QuerySupplierList, QueryVoucherModelList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { StatusFormat, UseTypeFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import { Message, MessageBox } from 'element-ui'
import EditVoucherModel from './EditVoucherModel.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditVoucherModel,
  },
})
export default class VoucherList extends Vue {
  private queryParam = {
    useType: 0,
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private supplierOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '使用类别', param: 'useType' , type: 'select', selectData: constant.UseType},
    this.supplierQueryParam,
    { title: '提货卷名称', param: 'voucherName' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建提货卷', type: 'primary', click: this.openAdd }
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '使用类别', param: 'useType', formatter: UseTypeFormat},
    { title: '模版编号', param: 'voucherModelNo' },
    { title: '提货卷名称', param: 'voucherName' },
    { title: '使用说明', param: 'voucherExplain', overflow: true},
    { title: '主标题', param: 'mainTitle'},
    { title: '副标题', param: 'viceTitle'},
    { title: '供应商简称', param: 'supplierSimpleName'},
    { title: '发放数量（张/用户）', param: 'count'},
    { title: '状态', param: 'status', formatter: StatusFormat},
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEdit },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow }
      ],
    },
  ]

  public async created() {
    this.loadData()
    await this.loadSupplier()
  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  public openEdit(data: any){
    const d = this.$refs.EditVoucherModel as EditVoucherModel
    d.open({id: data.id})
  }
  public openAdd(data: any){
    const d = this.$refs.AddVoucherModel as EditVoucherModel
    d.open({useType: this.queryParam.useType})
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryVoucherModelList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
  
  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteVoucherModel({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
